import { CoverageProduct } from '../../../dto/marketableProduct';
import { type PurchasePathState } from '../../types/initialState';
import DiscountAction from '../common/DiscountAction';
import styles from '../CoverageSection/CoverageSection.module.scss';
import CoverageHeading from '../CoverageSelector/CoverageHeading';
import CoverageInfoModal from '../CoverageSelector/CoverageInfoModal';
import CoverageStepper from '../CoverageSelector/CoverageStepper';
import { DiscountType } from 'dto/CoveragePremium';
import {
  useSelectedPremiums,
  useSelectablePremiums,
} from 'state/selectors/coverageSelectors';
import { getInitialState } from 'utils';
import { getDiscount } from 'utils/premium-utils';

interface Props {
  displayDetails: boolean;
}

const CriticalIllness = ({ displayDetails }: Props) => {
  const { marketableProduct } = getInitialState() as PurchasePathState;
  const selectedSumInsuredPremiums = useSelectedPremiums();
  const criticalIllnessSelectablePremiums = useSelectablePremiums(
    CoverageProduct.CRITICAL_ILLNESS
  );

  if (!criticalIllnessSelectablePremiums) {
    // Return null to avoid error throwing on page refresh
    return null;
  }

  const coverage = marketableProduct.coverages.find(
    (c) => c.coverageProduct === CoverageProduct.CRITICAL_ILLNESS
  );

  if (!coverage) {
    throw new Error(
      `No coverage found for coverageProduct: ${CoverageProduct.LIFE}`
    );
  }

  const ciPremium =
    selectedSumInsuredPremiums[CoverageProduct.CRITICAL_ILLNESS];

  if (!ciPremium) {
    return null;
  }

  const discount = getDiscount(
    ciPremium,
    criticalIllnessSelectablePremiums,
    DiscountType.WAIT_PERIOD_DISCOUNT
  );

  return (
    <div
      data-testid={`coverageTile-${coverage.coverageProduct}`}
      className={styles.coverageTile}>
      <CoverageHeading
        coverage={coverage}
        premium={ciPremium}
        discountComponent={
          discount ? (
            <DiscountAction
              discount={discount}
              discountType={DiscountType.WAIT_PERIOD_DISCOUNT}
              textKey={'insurances.discountIncluded'}
            />
          ) : null
        }
        displayDetails={displayDetails}
      />
      {displayDetails && (
        <CoverageStepper
          coverage={coverage}
          premium={ciPremium}
          selectablePremiums={criticalIllnessSelectablePremiums}
        />
      )}
      <CoverageInfoModal coverage={coverage} />
    </div>
  );
};

export default CriticalIllness;
